import { Component, Input } from '@angular/core';
import { sportInterface } from 'src/app/configs/sport';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor, NgClass, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-how-to-train',
    templateUrl: './how-to-train.component.html',
    styleUrls: ['./how-to-train.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        TranslateModule,
        RouterLink
    ],
})
export class HowToTrainComponent {

    @Input() data: Array<sportInterface>;

    displayExplanation(item) {
        this.data.find(el => el.active).active = false;
        item.active = true;
    }
}
